// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__7eJgR","title":"Images90_title__U6lQ7","images":"Images90_images__2v-1c"};